import { Paper } from '@material-ui/core';
import CustomCheckbox from 'components/CustomCheckbox';
import CustomTextField from 'components/Input/CustomTextField';
import React, { useEffect, useState } from 'react';
import { SHyperLink } from 'style/CommonStyledComponent';
import styled from 'styled-components/macro';
import { siteInfoLookup, studyInfoLookup } from 'utility/formLookup';
import { produce } from 'utility/general';
import CompareModal from './CompareModal';

const SLayout = styled.div`
    border: 2px solid #808080;
    display: flex;
`;

const SNumberLayout = styled.div`
    width: 30px;
    flex-shrink: 0;
    border-right: 2px solid #808080;
    display: flex;
    justify-content: center;
    padding-top: 5px;
`;

const STypeLayout = styled.div`
    width: 200px;
    flex-shrink: 0;
    padding: 5px;
    border-right: 2px solid #808080;
    font-weight: bold;
    background: #f9f9f9;
    display: flex;
    align-items: center;
`;

const SValueContainer = styled.div`
    flex: 1;
    display: flex;
    padding: 5px;
    align-items: center;
`;

const SRowContainer = styled.div`
    border-bottom: 2px solid #808080;
    flex-grow: 1;
    display: flex;
`;

const SContentLayout = styled.div`
    flex-grow: 1;
`;

const SValueLayout = styled.div`
    flex: 1;
    padding: 5px;
    display: flex;
    align-items: center;
`;

const STitle = styled.div`
    flex: 1;
    flex-shrink: 0;
    padding: 5px;
    background: #f9f9f9;
    font-weight: bold;
    font-size: 14px;
`;

const SAmendmentValue = styled.div`
    flex: 1;
    flex-shrink: 0;
    padding: 5px;
`;

const SProposedBySection = styled.div`
    flex: 1;
    border-right: 2px solid #808080;
    display: flex;
`;

const SRiskSection = styled.div`
    flex: 1;
    display: flex;
`;

const AmendmentItem = ({
    index = 1,
    applicationDetail,
    data = {},
    onDataUpdate = () => null,
    forceErrorDisplay = false,
    onValid = (isValid) => null,
    isAmendmentCreated = false,
    hasPermission,
}) => {
    const [increaseRisk, setRisk] = useState(data.increaseRisk);
    const [reasonForChanges, setReason] = useState(data.reasonForChanges ?? '');
    const [proposedBy, setProposedBy] = useState(data.proposedBy ?? '');
    const [validation, setValidation] = useState({});
    const [isCompareShow, setCompareShow] = useState(false);
    const [amendInstitution, setAmendInstitution] = useState('');

    const isDisabled = isAmendmentCreated || !hasPermission;

    useEffect(() => {
        onValid(Object.values(validation).every((item) => item));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validation]);

    const notifyParentState = (key, value) => {
        onDataUpdate(index, {
            proposedBy,
            increaseRisk,
            reasonForChanges,
            type: data.type,
            fieldName: data.fieldName,
            currentValue: data.currentValue,
            amendmentValue: data.amendmentValue,
            formKey: data.formKey,
            [key]: value,
        });
    };

    const [decisionValues] = useState([
        { key: 'yes', value: false, display: 'Yes' },
        { key: 'no', value: false, display: 'No' },
    ]);

    const getTrueFalseValue = () => {
        const risk = increaseRisk ?? data?.increaseRisk;

        if (risk === true) {
            return 'yes';
        } else if (risk === false) {
            return 'no';
        } else {
            return null;
        }
    };

    const getValue = (formattedValue) => {
        const result = formattedValue.split('~:(');
        return result;
    };

    const getTypeDisplay = (type) => {
        if (type === 'SITE_INFO') {
            return 'Site Info';
        } else if (type === 'STUDY_INFO') {
            return 'Study Info';
        } else {
            return type;
        }
    };

    const shouldCompareShow = () => {
        const isStudyType = data.type === 'STUDY_INFO' || data.type === 'Study Info';

        if (isStudyType) {
            return studyInfoLookup()[data.formKey]?.isTextArea;
        } else {
            return siteInfoLookup()[data.formKey]?.isTextArea;
        }
    };

    useEffect(() => {
        if (applicationDetail?.applicationForm?.amendInstitution) {
            setAmendInstitution(applicationDetail?.applicationForm?.amendInstitution);
        }
    }, [applicationDetail]);

    return (
        <Paper>
            <SLayout>
                {isCompareShow && (
                    <CompareModal
                        originalText={data.currentValue}
                        changedText={data.amendmentValue}
                        onClose={() => setCompareShow(false)}
                    />
                )}
                <SNumberLayout>{index}.</SNumberLayout>
                <SContentLayout>
                    <SRowContainer>
                        <STypeLayout>Study Info/Site Info</STypeLayout>
                        <SValueContainer>
                            {amendInstitution !== ''
                                ? `${getTypeDisplay(data.type) + ' (' + amendInstitution + ')'}`
                                : `${getTypeDisplay(data.type)}`}
                        </SValueContainer>
                    </SRowContainer>
                    <SRowContainer>
                        <STypeLayout>Field Name/Document Name</STypeLayout>
                        <SValueContainer>{data.fieldName}</SValueContainer>
                    </SRowContainer>
                    <SRowContainer>
                        <STitle style={{ borderRight: '2px solid #808080' }}>Current condition</STitle>
                        <STitle style={{ display: 'flex' }}>
                            Amendment
                            {shouldCompareShow() && (
                                <SHyperLink style={{ marginLeft: 10 }} onClick={() => setCompareShow(true)}>
                                    (Compare)
                                </SHyperLink>
                            )}
                        </STitle>
                    </SRowContainer>
                    <SRowContainer>
                        <SAmendmentValue style={{ borderRight: '2px solid #808080' }}>
                            {data?.currentValue &&
                                getValue(data.currentValue).map((item, index) => {
                                    return (
                                        <div key={index} style={{ padding: '2px 0', wordBreak: 'break-all' }}>
                                            {item}
                                        </div>
                                    );
                                })}
                        </SAmendmentValue>
                        <SAmendmentValue>
                            {data?.amendmentValue &&
                                getValue(data.amendmentValue).map((item, index) => {
                                    return (
                                        <div key={index} style={{ padding: '2px 0', wordBreak: 'break-all' }}>
                                            {item}
                                        </div>
                                    );
                                })}
                        </SAmendmentValue>
                    </SRowContainer>

                    <SRowContainer>
                        <SProposedBySection>
                            <STypeLayout>Proposed by</STypeLayout>
                            <SValueContainer>
                                {isDisabled ? (
                                    data?.proposedBy
                                ) : (
                                    <div style={{ padding: 5, width: '100%' }}>
                                        <CustomTextField
                                            value={proposedBy ?? data?.proposedBy}
                                            forceErrorDisplay={forceErrorDisplay}
                                            disabled={isDisabled}
                                            validators={['isRequired']}
                                            maxLength={255}
                                            isValidValue={(isValid) => {
                                                setValidation(
                                                    produce((draft) => {
                                                        draft.proposedBy = isValid;
                                                    }),
                                                );
                                            }}
                                            onChange={(e) => {
                                                setProposedBy(e.target.value);
                                                notifyParentState('proposedBy', e.target.value);
                                            }}
                                        />
                                    </div>
                                )}
                            </SValueContainer>
                        </SProposedBySection>
                        <SRiskSection>
                            <STypeLayout style={{ width: 300 }}>Will change increase risk to participants?</STypeLayout>
                            <SValueLayout>
                                {isDisabled ? (
                                    <span>{data?.increaseRisk ? 'Yes' : 'No'}</span>
                                ) : (
                                    <CustomCheckbox
                                        defaultData={decisionValues}
                                        value={[getTrueFalseValue()]}
                                        radioButton
                                        isRequired
                                        disabled={isDisabled}
                                        forceErrorDisplay={forceErrorDisplay}
                                        isValidValue={(isValid) => {
                                            setValidation(
                                                produce((draft) => {
                                                    draft.risk = isValid;
                                                }),
                                            );
                                        }}
                                        onItemChange={(key, value) => {
                                            if (value === true) {
                                                const index = decisionValues.findIndex((draftItem) => {
                                                    return draftItem.key === key;
                                                });
                                                const decision = index === 0;
                                                setRisk(decision);
                                                notifyParentState('increaseRisk', decision);
                                            }
                                        }}
                                    />
                                )}
                            </SValueLayout>
                        </SRiskSection>
                    </SRowContainer>

                    <SRowContainer style={{ borderBottom: 'none' }}>
                        <STypeLayout>Reason for change</STypeLayout>
                        <SValueContainer>
                            {isDisabled ? (
                                data?.reasonForChanges
                            ) : (
                                <div style={{ padding: 5, width: '100%' }}>
                                    <CustomTextField
                                        validators={['isRequired']}
                                        value={reasonForChanges ?? data?.reasonForChanges}
                                        isTextArea
                                        maxLength={255}
                                        textAreaMinRow={3}
                                        disabled={isDisabled}
                                        isValidValue={(isValid) => {
                                            setValidation(
                                                produce((draft) => {
                                                    draft.reason = isValid;
                                                }),
                                            );
                                        }}
                                        forceErrorDisplay={forceErrorDisplay}
                                        onChange={(e) => {
                                            setReason(e.target.value);
                                            notifyParentState('reasonForChanges', e.target.value);
                                        }}
                                    />
                                </div>
                            )}
                        </SValueContainer>
                    </SRowContainer>
                </SContentLayout>
            </SLayout>
        </Paper>
    );
};

export default AmendmentItem;
